/**
 * 监听内容滚动到顶部
 * @date 2021-11-01
 * @author Kody
 */
import { useCallback, useEffect } from 'react';
import { $window, docElement } from '@umu/umu-dom';

export const useScrollTop = (callback: () => void, depend: any = []) => {
    const onScroll = useCallback(() => {
        if (docElement.scrollTop === 0) {
            callback();
        }
    }, [depend]);

    useEffect(() => {
        $window.addEventListener('scroll', onScroll);
        return () => {
            $window.removeEventListener('scroll', onScroll);
        };
    }, [depend]);
};
